export const CONTACT_PRESENCE_CHANGED = 'ContactPresenceChanged';
export const WATCH_CONTACT_PRESENCE = 'WatchContactPresence';
export const ON_CONTACT_DISCONNECTED = 'OnContactDisconnected';
export const CHECK_USER_DISCONNECTED = 'CheckUserDisconnect';
export const CHECK_USER_PRESENCE_RESPONSE =
  'CheckUserPresenceResponse';
